import type { Api, Vendor } from '@cruz-com/lookup'
import { baseURL, formatFetchError, getHeader } from '../util'

export async function requestGooglePlace(id: string): Promise<Api.Result<Vendor.Location>> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/data/location/request-google-place?id=${id}`, {
      method: 'GET',
      headers,
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
